import { render, staticRenderFns } from "./ShareBlock.htm?vue&type=template&id=2fbc2e79&scoped=true&"
import script from "./ShareBlock.ts?vue&type=script&lang=js&"
export * from "./ShareBlock.ts?vue&type=script&lang=js&"
import style0 from "./ShareBlock.scss?vue&type=style&index=0&id=2fbc2e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc2e79",
  null
  
)

export default component.exports